import { useFilterQueryContext } from 'src/contexts/FilterQueryContext';
import { DateRangeSelector } from 'src/core/POS/DateRangeSelector';
import { PosTextField } from 'src/core/POS/PosTextField';
import { ContentId } from 'src/utils/constants/contentId';
import { PurchaseDateRangePresetNames } from 'src/utils/dateTimeUtils';
import { UIReportV2SaleTotalCostAdjustmentsQuery } from 'src/WebApiController';

import { FilterToolbarItemId } from '../Filters';

export const saleCostAdjustmentsReportMandatoryFiltersToShow: FilterToolbarItemId[] =
  ['adjustmentsSinceDate'];

export function useSaleCostAdjustmentsReportFilters({
  isHorizontalLayout,
}: {
  isHorizontalLayout?: boolean;
}) {
  const { initialQuery, tempQuery, setTempQuery } =
    useFilterQueryContext<UIReportV2SaleTotalCostAdjustmentsQuery>();

  return {
    filters: [
      {
        titleContentId: ContentId.Date,
        type: 'row',
        items: [
          {
            filterId: 'adjustmentsSinceDate' as FilterToolbarItemId,
            labelContentId: ContentId.ChangeDate,
            filterQueryKeys: ['adjustmentsSinceDate'] as FilterToolbarItemId[],
            filterItem: (
              <DateRangeSelector
                useRelativePresets
                presetNames={PurchaseDateRangePresetNames}
                value={tempQuery.adjustmentsSinceDate}
                defaultValue={initialQuery.adjustmentsSinceDate}
                onChange={({ value }) =>
                  setTempQuery({
                    ...tempQuery,
                    adjustmentsSinceDate: value,
                  })
                }
                onBlur={({ value }) =>
                  setTempQuery({
                    ...tempQuery,
                    adjustmentsSinceDate: value,
                  })
                }
              />
            ),
          },
        ],
      },
      {
        titleContentId: ContentId.Filters,
        type: 'row',
        items: [
          {
            filterId: 'adjustmentType' as FilterToolbarItemId,
            labelContentId: ContentId.AdjustmentType,
            filterQueryKeys: ['adjustmentType' as FilterToolbarItemId],
            filterItem: (
              <PosTextField
                style={{ width: '100%' }}
                value={tempQuery.adjustmentType || ''}
                placeholder="All"
                onChange={(e) =>
                  setTempQuery({
                    ...tempQuery,
                    adjustmentType: e.target.value || null,
                  })
                }
              />
            ),
          },
        ],
      },
    ],
  };
}
